<div class="row-container">
  @for (product of productRow(); track product) {
    <app-product-card [product]="product" [cardWidth]="cardWidth()"></app-product-card
      >
    }
  </div>
